import React, { useRef } from 'react';
import { Text, FormModal, Icons, Button, i18n, tokens } from '@simplybenefits/sb-ui-library';
import Icon from '@mui/material/Icon';
import { connect } from 'react-redux';

/**
 * Component representing the form for Enriched Academy benefits.
 * 
 * @param {object} props - The props for the component.
 * @param {React.RefObject} props.hiddenSubmitButton - Ref for the hidden submit button.
 * @param {object} props.user - The user data.
 * @returns {JSX.Element} The Enriched Academy form component.
 */
const EnrichedAcademyForm = ({ hiddenSubmitButton, user }) => (
    <form
        action="https://sso.enrichedacademy.com/sso/ssoverification.php"
        method="post"
        target="_blank"
        id="CWEAFORM"
    >
        <input type="hidden" value={ `${ user.meta.firstname }` } name="fname" id="CWEAFNAME" />
        <input type="hidden" value={ user.meta.lastname } name="lname" id="CWEALNAME" />
        <input type="hidden" value={ user.meta.email } name="email" id="CWEAEMAIL" />
        <input type="hidden" value="0" name="indicator" id="indicator" />
        <input type="hidden" placeholder="en: English, fr: French " value={ user.meta.language } name="preferred_language" id="preferred_language" />
        <input type="hidden" value="SMpli4acbPxT" name="token" id="token" />
        <input type="hidden" value="simplybenefits.com" id="CHECKDOMAIN" name="host" />
        <input type="submit" name="postdata" value="test" ref={hiddenSubmitButton} style={{ display: 'none' }} />
    </form>
);

/**
 * Component representing a modal for Enriched Academy benefits.
 * 
 * @param {object} props - The props for the component.
 * @param {boolean} props.open - Whether the modal is open or not.
 * @param {Function} props.toggleOpen - Function to toggle the modal open/close state.
 * @param {object} props.user - The user data.
 * @returns {JSX.Element} The Enriched Academy modal component.
 */
const EnrichedAcademyModal = ({ open, toggleOpen, user }) => {
    // Ref to access the hidden submit button in the form
    const hiddenSubmitButton = useRef(null);

    /**
     * Function to trigger form submission
     */
    const handleSubmit = () => {
        if (hiddenSubmitButton.current) {
            hiddenSubmitButton.current.click();
        }
    };

    return (
        <FormModal
            open={ open }
            close={toggleOpen}
            customContainerStyle={{ width: 550 }}
        >
            <Text
                extraLarge
                bold
                align={"left"}
                marginBottom={10}
            >
                { i18n.t(tokens.labels.coverage.enrichedAcademyBenefit) }
            </Text>

            <Text
                light
                medium
                customStyle={{ paddingLeft: 25, paddingTop: 25 }}
            >
                { i18n.t(tokens.labels.coverage.enrichedAcademyPrivacyStatement) }
            </Text>

            <div
                style={{
                    flexDirection: "row",
                    marginTop: 20,
                    width: "100%"
                }}
            >
                <Button
                    transparent
                    onClick={ toggleOpen }
                    fullWidth
                    customStyle={{ width: "50%" }}
                >
                    { i18n.t(tokens.buttons.cancel).toUpperCase() } 
                </Button>
                <Button
                    onClick={handleSubmit}
                    fullWidth
                    customStyle={{ width: "50%" }}
                    color="primary"
                >
                    { i18n.t(tokens.buttons.continue).toUpperCase() }
                    <Icon >
                        { Icons.Redirect }
                    </Icon>
                </Button>
            </div>

            <EnrichedAcademyForm 
                hiddenSubmitButton={hiddenSubmitButton}
                user={user} 
            />
        </FormModal>
    );
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    user: state.user
});


export default connect(mapStateToProps)(EnrichedAcademyModal);